import { Fragment } from "react";
import { any, has } from "ramda";
import { Header3, Div, MainText } from "@base-ui";
import { Accordion } from "@interdependence-ui";
import { StyledTechnicalDescriptionsContent } from "./accordionDescription.styles";
import { cleanHtml } from "utils/cleanHtml";
import { convertHtmlstringToHtml } from "utils/convertHtmlstringToHtml";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AccordionDescriptions(_ref) {
  var metadata = _ref.metadata;
  var generalDescriptions = [{
    id: "interpretationTextPersonell",
    title: "Om indikatorn",
    icon: "thematic"
  }, {
    id: "sourcesOfError",
    title: "Att tänka på vid tolkning",
    icon: "error"
  }].map(function (info) {
    if (!metadata || !metadata[info.id]) return null;
    var content = cleanHtml(metadata[info.id], []).split("\n").map(function (paragraph, idx) {
      return /*#__PURE__*/_jsx(MainText, {
        children: paragraph
      }, idx);
    });
    return /*#__PURE__*/_jsx(Accordion, {
      id: info.id,
      title: info.title,
      icon: info.icon,
      children: content
    }, info.id);
  });
  var technicalDescriptions = [{
    label: "Typ av indikator",
    id: "indicatorType"
  }, {
    label: "Täljare",
    id: "numeratorDefinition"
  }, {
    label: "Nämnare",
    id: "denominatorDefinition"
  }, {
    label: "Regiontillhörighet",
    id: "regionalAffinityCalculation"
  }, {
    label: "Mätpopulationsdefinition",
    id: "measurePopulationDefinition"
  }];
  var technicalDescriptionsMarkup;
  if (any(function (description) {
    return has(description.id, metadata);
  }, technicalDescriptions)) {
    var content = technicalDescriptions.map(function (description) {
      if (metadata[description.id]) {
        var cleanedText = cleanHtml(metadata[description.id], ["table", "tbody", "tr", "td", "th", "thead", "strong", "em", "p", "a", "u", "ul", "li", "ol"]).replace(/\n\n/g, "<br/>").replace(/\n/g, "<br/>");
        var converted = convertHtmlstringToHtml(cleanedText);
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(Header3, {
            children: description.label
          }), /*#__PURE__*/_jsx(StyledTechnicalDescriptionsContent, {
            children: converted
          })]
        }, description.id);
      }
      return null;
    });
    technicalDescriptionsMarkup = /*#__PURE__*/_jsx(Accordion, {
      id: "technicalDescriptions",
      title: "Teknisk beskrivning",
      icon: "text",
      children: content
    });
  }
  return /*#__PURE__*/_jsxs(Div, {
    style: {
      margin: "0 10px 20px 0"
    },
    children: [generalDescriptions, technicalDescriptionsMarkup]
  });
}